import { rankTotal } from "@/mocks/rankings";
import { articles } from "@/mocks/articles";
import RankList from "@/components/base/RankList";
import SectionHeading from "@/components/base/SectionHeading";
import ArticleCard from "@/components/base/ArticleCard";

export default function HotRankSection() {
  const top = rankTotal.slice(0, 7);
  const picks = articles.slice(3, 7);

  return (
    <section id="hot" className="scroll-mt-40">
      <SectionHeading
        eyebrow="今日热榜"
        title="热度最高的爆料吃瓜话题"
        desc="按当日讨论量排序，榜单每两小时刷新一次，箭头代表相对上一次的变化。"
        moreText="完整榜单"
        morePath="/ranking"
      />

      <div className="grid grid-cols-1 gap-6 lg:grid-cols-3">
        <div className="rounded-card border border-background-200/80 bg-background-50 p-3 md:p-4 lg:col-span-2">
          <RankList items={top} />
        </div>

        <aside className="rounded-card border border-background-200/80 bg-secondary-50 p-5">
          <h3 className="flex items-center gap-2 font-heading text-sm font-bold text-foreground-950">
            <span className="flex h-4 w-4 items-center justify-center">
              <i className="ri-bookmark-3-line text-secondary-600"></i>
            </span>
            编辑推荐
          </h3>
          <p className="mt-2 text-xs leading-relaxed text-foreground-600">
            这几条不一定最热，但信息量足，适合想多看两眼的读者。
          </p>
          <div className="mt-4 flex flex-col gap-3">
            {picks.map((item) => (
              <ArticleCard key={item.slug} article={item} variant="horizontal" />
            ))}
          </div>
        </aside>
      </div>
    </section>
  );
}